import actionTypes from "../actionTypes";

export const updateList = (target, list) =>
    ({ type: actionTypes.list.updateList, payload: { target, list } });

export const actions = {
    updateList
};
